export default __webpack_public_path__ + "static/media/error.3112d8cc.svg";